import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-actions-popover',
  templateUrl: './media-actions-popover.component.html',
  styleUrls: ['./media-actions-popover.component.scss'],
})
export class MediaActionsPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
